module.exports = __webpack_public_path__ + "img/icon06.03875228.png";